// Product thumbnail and capacity button interaction handler
class ProductInteraction {
  constructor() {
    this.isDesktop = window.innerWidth >= 1024;
    this.init();
  }

  init() {
    // Set default active state for capacity buttons
    this.setDefaultActiveState();
    
    // Add event listeners based on device type
    if (this.isDesktop) {
      this.initDesktopEvents();
    } else {
      this.initMobileEvents();
    }

    // Handle window resize
    window.addEventListener('resize', () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth >= 1024;
      
      if (wasDesktop !== this.isDesktop) {
        this.removeAllEvents();
        if (this.isDesktop) {
          this.initDesktopEvents();
        } else {
          this.initMobileEvents();
        }
      }
    });
  }

  setDefaultActiveState() {
    const defaultButtons = document.querySelectorAll('.capacity-button[data-default="true"]');
    defaultButtons.forEach(button => {
      button.classList.add('active');
    });
  }

  initDesktopEvents() {
    // Thumbnail hover events
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('mouseenter', (e) => {
        const hoverImage = e.currentTarget.dataset.hoverImage;
        if (hoverImage) {
          e.currentTarget.querySelector('img').src = hoverImage;
        }
      });

      thumbnail.addEventListener('mouseleave', (e) => {
        const defaultImage = e.currentTarget.dataset.defaultImage;
        if (defaultImage) {
          e.currentTarget.querySelector('img').src = defaultImage;
        }
      });

      thumbnail.addEventListener('click', (e) => {
        const productUrl = e.currentTarget.dataset.productUrl;
        if (productUrl) {
          window.location.href = productUrl;
        }
      });
    });

    // Capacity button hover events
    const capacityButtons = document.querySelectorAll('.capacity-button');
    capacityButtons.forEach(button => {
      button.addEventListener('mouseenter', (e) => {
        this.handleCapacityButtonHover(e.currentTarget);
      });
    });
  }

  initMobileEvents() {
    // Thumbnail touch events
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('touchstart', (e) => {
        const hoverImage = e.currentTarget.dataset.hoverImage;
        if (hoverImage) {
          e.currentTarget.querySelector('img').src = hoverImage;
        }
      });

      thumbnail.addEventListener('touchend', (e) => {
        const defaultImage = e.currentTarget.dataset.defaultImage;
        if (defaultImage) {
          e.currentTarget.querySelector('img').src = defaultImage;
        }
      });
    });

    // Capacity button touch events
    const capacityButtons = document.querySelectorAll('.capacity-button');
    capacityButtons.forEach(button => {
      button.addEventListener('touchstart', (e) => {
        this.handleCapacityButtonHover(e.currentTarget);
      });
    });
  }

  handleCapacityButtonHover(button) {
    // Remove active class from all buttons
    const allButtons = document.querySelectorAll('.capacity-button');
    allButtons.forEach(btn => btn.classList.remove('active'));
    
    // Add active class to current button
    button.classList.add('active');
  }

  removeAllEvents() {
    // Remove all event listeners
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    const capacityButtons = document.querySelectorAll('.capacity-button');
    
    thumbnails.forEach(thumbnail => {
      thumbnail.replaceWith(thumbnail.cloneNode(true));
    });
    
    capacityButtons.forEach(button => {
      button.replaceWith(button.cloneNode(true));
    });
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductInteraction();
}); 